import axiosInstance from '../config/axios';

const EMPTY_ROSTER = { author_admins: [], coordinators: [], co_authors: [], reviewers: [], approvers: [] };

/**
 * Role-scoped candidate lists for a study's Study Team pickers — keyed by the
 * same role fields Study Team uses (author_admins/coordinators/co_authors/
 * reviewers/approvers). Each bucket only contains people whose Hub
 * resource_access grant resolves to this study and maps to that role.
 */
export async function fetchActiveUsersDirectory(projectId) {
  const res = await axiosInstance.get('/users/directory', { params: { projectId } });
  const body = res.data;
  if (!body?.success) {
    throw new Error(body?.message || 'Failed to load users');
  }
  return { ...EMPTY_ROSTER, ...(body.roster || {}) };
}
